/**
 * Se utiliza para administrar el estado de la miga de pan
 */
export class BreadCrumbST {

  /** Es el nombre del modulo donde pertenece la URL */
  public modulo: string | any;

  /** URL actual de la miga de pan */
  public url: string | any;

  /** Icono del modulo seleccionado */
  public icono: string | any;

  /** Variable que almacena la url correspondiente al manual en pdf */
  public urlManualPDF: string | any;

  /** Variable que almacena la url correspondiente al manual en video */
  public urlManualVideo: string | any;

  /** Nombre del submodulo seleccionado */
  public labelSubmodulo: string | any;
}
